export { SlideSvgGlyph } from "#slide-svg-glyph";
